module.exports = __webpack_public_path__ + "img/pic-jou-wong.67fb39e0.jpg";